 
import { createSlice } from '@reduxjs/toolkit';
import {
  SetBreadcrumbsAction,
  BreadcrumbsState,
  MakeBreadcrumbsAction,
} from './breadcrumbs.types';
import { createSliceHook, makeActionCreator } from '../helpers';

const initialState: BreadcrumbsState = {
  data: [],
};

const { actEmpty, actResolve } = makeActionCreator<BreadcrumbsState>();

export const breadcrumbsSlice = createSlice({
  name: 'breadcrumbs',
  initialState,
  reducers: {
    setBreadcrumbs: actResolve<SetBreadcrumbsAction['payload']>('data', null, null),
    makeBreadcrumbs: actEmpty<MakeBreadcrumbsAction['payload']>(),
    resetBreadcrumbs: actEmpty(),
  },
});

export const { actions } = breadcrumbsSlice;

export const useBreadcrumbsSlice = createSliceHook(
  'breadcrumbs',
  breadcrumbsSlice.actions
);
